import axios, { AxiosError } from 'axios';
import apiConfig from '../config/apiConfig';
import errorHandler from '../config/apiErrorHandler';
import storageManager from '../utils/localStorage';
import { AUTH_STORAGE_KEY } from '../utils/apiAuthToken';
import * as Sentry from '@sentry/browser'
import { authModalState } from 'src/modules/Auth/AuthModal/useAuthModal';

axios.defaults.baseURL = apiConfig.apiUrl;
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.post['Content-Type'] = apiConfig.contentType;
axios.defaults.headers.put['Content-Type'] = apiConfig.contentType;

axios.interceptors.request.use((config) => {
  const auth = storageManager.get(AUTH_STORAGE_KEY);
  config.headers['Auth-Type'] = apiConfig.authType
  if (auth && auth.idToken && auth.idToken.jwtToken) {
    config.headers.Authorization = `Basic ${auth.idToken.jwtToken}`;
    return config;
  }
  return config;
});

axios.interceptors.response.use(
  response => Promise.resolve(response),
  (error: AxiosError) => {
    Sentry.withScope(scope => {
      scope.setExtras(error.request);
      Sentry.captureException(error);
    });
    const errorResponse = errorHandler(error.response);
    if (error && error.response && error.response.status === 403) {
      authModalState.next({ isModalOpen: true, refresh: true });
    }
    return Promise.reject(errorResponse);
  }
);

export const apiService = axios;



// WEBPACK FOOTER //
// ./src/share/services/apiService.ts